import { render, staticRenderFns } from "./dynamic-field.vue?vue&type=template&id=d590271c&scoped=true"
import script from "./dynamic-field.vue?vue&type=script&lang=ts"
export * from "./dynamic-field.vue?vue&type=script&lang=ts"
import style0 from "./dynamic-field.vue?vue&type=style&index=0&id=d590271c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d590271c",
  null
  
)

export default component.exports